"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
require("isomorphic-fetch");
function fetchData(url, body, auth) {
    return __awaiter(this, void 0, void 0, function* () {
        return fetch(url, {
            method: body ? 'POST' : 'GET',
            headers: Object.assign({ 'Content-Type': 'text/plain;charset=UTF-8' }, (auth && {
                Authorization: `Basic ${Buffer.from(`${auth.username}:${auth.password}`).toString('base64')}`,
            })),
            body: body ? JSON.stringify(body) : undefined,
        })
            .then((res) => res.json())
            .then((res) => res);
    });
}
exports.default = fetchData;
